<template>
  <span>
    <h3 tabindex="0">Seja bem vindo {{ usuario.nome }}!</h3>
    <b-row>
      <b-col v-if="texto_apresentacao !== 'null'" sm="12">
        <br>
        <div tabindex="0" v-html="texto_apresentacao" />
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col class="col-md-6 col-sm-12">
        <b-button class="card-button" tabindex="0"
          style="height: 150px; width: 100%; margin-bottom: 5%; background-color: #4BBCA7; font-size: 20px; vertical-align: middle; cursor: pointer;"
          @click="navigate('sala/consulta')">
          <strong>Assistir as Transmissões</strong>
          <br>
          <span class="fa fa-play fa-2x"></span>
        </b-button>
      </b-col>
      <b-col class="col-md-6 col-sm-12">
        <b-button class="card-button" tabindex="0"
          style="height: 150px; width: 100%; margin-bottom: 5%; background-color: #48B5DD;  font-size: 20px; vertical-align: middle; cursor: pointer;"
          @click="navigate('proposta-entrada')">
          <strong>Fórum</strong>
          <br>
          <span class="fa fa-file fa-2x"></span>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-md-6 col-sm-12">
        <b-button class="card-button" tabindex="0"
          style="height: 150px; width: 100%; margin-bottom: 5%; background-color: #ffe605; font-size: 20px; vertical-align: middle; cursor: pointer;"
          @click="navigate('salachat')">
          <strong>Chats</strong>
          <br>
          <span class="fa fa-comments fa-2x"></span>
        </b-button>
      </b-col>
      <b-col class="col-md-6 col-sm-12">
        <b-button class="card-button" tabindex="0"
          style="height: 150px; width: 100%; margin-bottom: 5%; background-color: #ff0505;  font-size: 20px; vertical-align: middle; cursor: pointer;"
          @click="navigate('mocao')">
          <strong>Moções</strong>
          <br>
          <span class="fa fa-book fa-2x"></span>
        </b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="3" v-for="arquivo in arquivos.data" :key="arquivo.id">
        <b-button @click="abrirDocumento(arquivo.arquivo)" tabindex="0" :class="'card-button ' + arquivo.cor_bloco"
          style="height: 150px;  width: 100%; margin-bottom: 5%; font-size: 15px; vertical-align: middle; cursor: pointer;">
          <strong style="white-space: pre-line;">{{ arquivo.titulo }}</strong>
        </b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="3" v-for="link in links.data" :key="link.id">
        <b-button @click="abrirUrl(link.url)" tabindex="0" :class="'card-button'" 
          :style="'background-color:'+ link.cor_bloco +'; height: 150px;  width: 100%; margin-bottom: 5%; font-size: 15px; vertical-align: middle; cursor: pointer;'">
          <strong style="white-space: pre-line;">{{ link.titulo }}</strong>
        </b-button>
      </b-col>
    </b-row>
  </span>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'Home',
  created() {
    let usuario = SessionStorage.get('usuario')

    if (!usuario) {
      this.$router.push('/externa')
    }
    this.carregarArquivos()
    this.carregarLinks()
  },
  data() {
    return {
      conferencias: [],
      perfis: [],
      arquivos: [],
      links: [],
      conferencia_id: null,
      texto_apresentacao: SessionStorage.get('texto_apresentacao'),
      perfil_id: null
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      configurarConferencia: state => state.conferencia.configurarConferencia,
      mensagemConferencia: state => state.conferencia.mensagem
    }),
    perfil() {
      return this.$store.state.perfil.perfil
    },
  },
  mounted() {
    // CODE: Listar todas as conferências que o usuário ta vinculado
    let conferencias = this.usuario.conferencias

    if (!this.configurarConferencia && conferencias && conferencias.length > 1) {
      this.conferencias = []

      for (let i = 0; i < conferencias.length; i++) {
        let index = -1

        for (let j = 0; j < this.conferencias.length && index === -1; j++) {
          index = this.conferencias[j].value === conferencias[i].conferencia_id ? i : -1
        }

        if (index === -1) {
          this.conferencias.push({ value: conferencias[i].conferencia_id, text: conferencias[i].conferencia_nome })
        }
      }

      this.$bvModal.show('modalConferencia')
    }

    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }
  },
  methods: {
    navigate(route) {
      this.$router.push(route)
    },
    sucesso(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    carregarPerfis() {
      // CODE: Listar os perfis vinculados a conferência de acordo com o usuário
      this.perfil_id = null
      this.perfis = []
      let conferencias = this.usuario.conferencias

      for (let i = 0; i < conferencias.length; i++) {
        if (conferencias[i].conferencia_id === this.conferencia_id) {
          this.perfis.push({ value: conferencias[i].perfil_id, text: conferencias[i].perfil_nome })
        }
      }

      if (this.perfis.length === 1) {
        this.perfil_id = this.perfis[0].value
      }
    },
    carregarArquivos() {
      Vue.http.get('api/arquivos?status=1').then(response => {
        if (response.body.success) {
          this.arquivos = response.body.data
        }
      })
    },
    carregarLinks() {
      Vue.http.get('api/link?ativo=true').then(response => {
        if (response.body.success) {
          this.links = response.body.data
        }
      })
    },
    abrirDocumento(documento) {
      window.open(documento, '_blank')
    },
    abrirUrl(url){
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
.verde {
  background-color: #36b536;
}

.azul {
  background-color: #3f5ea1;
}

.amarelo {
  background-color: #ffe605;
}

.vermelho {
  background-color: #ff0505;
}

.roxo {
  background-color: #d505ff;
}

.card-button {
  text-align: center;
  border-radius: 15px;
  font-size: 15px;
}</style>


// WEBPACK FOOTER //
// src/pages/site/interna/Home.vue